import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagGD = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#A2001D",
  d: "M10.91 4.348A24.882 24.882 0 0 1 25 0a24.882 24.882 0 0 1 14.09 4.348L25 5.435 10.91 4.348Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "m25 25-1.595-1.596-.424.759L25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#496E2D",
  d: "M7.322 7.322c-9.763 9.763-9.763 25.592 0 35.356L25 25 7.322 7.322ZM42.678 7.322c9.763 9.763 9.763 25.592 0 35.356L25 25 42.678 7.322Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#A2001D",
  d: "M25 33.695a8.696 8.696 0 1 0 0-17.39 8.696 8.696 0 0 0 0 17.39Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "m25 16.304 1.95 6h6.308l-5.104 3.708 1.95 5.999L25 28.303l-5.104 3.708 1.95-6-5.103-3.708h6.308L25 16.304ZM25 0h-.008.017H25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#A2001D",
  d: "M25.008 0h-.016A24.92 24.92 0 0 0 7.324 7.321h35.352A24.921 24.921 0 0 0 25.008 0ZM7.324 42.678A24.922 24.922 0 0 0 25 50a24.922 24.922 0 0 0 17.676-7.32H7.324Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "m25 2.717.405 1.245h1.31l-1.06.77.404 1.246-1.06-.77-1.059.77.405-1.246-1.06-.77h1.31L25 2.717ZM18.938 2.717l.405 1.245h1.31l-1.06.77.404 1.246-1.06-.77-1.059.77.405-1.246-1.06-.77h1.31l.405-1.245ZM31.062 2.717l.405 1.245h1.31l-1.06.77.405 1.246-1.06-.77-1.06.77.406-1.246-1.06-.77h1.31l.404-1.245ZM25 44.021l.405 1.246h1.31l-1.06.77.404 1.245-1.06-.77-1.059.77.405-1.245-1.06-.77h1.31L25 44.02ZM18.938 44.021l.405 1.246h1.31l-1.06.77.404 1.245-1.06-.77-1.059.77.405-1.245-1.06-.77h1.31l.405-1.246ZM31.062 44.021l.405 1.246h1.31l-1.06.77.405 1.245-1.06-.77-1.06.77.406-1.245-1.06-.77h1.31l.404-1.246ZM7.618 24.587a2.174 2.174 0 0 1-3.674 2.325c-1.163-1.836-.489-4.836-.489-4.836s3 .674 4.163 2.51Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#A2001D",
  d: "M6.362 27.755a1.087 1.087 0 1 0 0-2.174 1.087 1.087 0 0 0 0 2.174Z"
}));
FlagGD.displayName = 'FlagGD';
export default withFlagWrapper(FlagGD);
//# sourceMappingURL=index.js.map